export { AtnDsSectionComponent as Component } from './section.component'
